/* Style Archive - video loading fix.
 *
 * Problem: the grid videos used to ship with `autoplay preload="auto"`, so the browser
 * opened one full-file download per video to the CDN (capped at ~6 connections per host).
 * They starve each other and none of them ever buffers - every one sits at readyState 0
 * with 0 bytes. The old inline nudge() also called play() on display:none tiles, because
 * getBoundingClientRect() returns all zeros for them and that passed its in-view test, so
 * hidden videos competed for the same slots.
 *
 * Fix: park every grid video (src moved to data-src, preload="none", autoplay removed) so
 * nothing loads up front, then hand the src back only to videos actually scrolled into
 * view, capped at MAX concurrent. The hero video above the grid is deliberately left alone.
 *
 * 2026 fix: this used to scope itself to `document.querySelector('.ews')`, i.e. the FIRST
 * .ews wrapper on the page. The archive used to be split across two custom-liquid blobs
 * (`.ews` and `.ews ews2`) and every one of the grid's videos lived in the second one, so
 * none of them were ever parked. Now every `.ews` grid on the page is covered.
 */
(function () {
  var MAX = 4;

  function init() {
    var vids = [].slice.call(document.querySelectorAll('.ews .mt video'));
    if (!vids.length) return;

    var active = [];

    /* Park everything: no source, no preload, no autoplay. */
    vids.forEach(function (v) {
      v.removeAttribute('autoplay');
      v.preload = 'none';
      v.muted = true;
      v.playsInline = true;
      v.loop = true;
      try { v.pause(); } catch (e) {}
      var src = v.getAttribute('src') || v.getAttribute('data-src');
      if (src) {
        v.setAttribute('data-src', src);
        v.removeAttribute('src');
        try { v.load(); } catch (e) {}
      }
    });

    function hidden(v) {
      var tile = v.closest ? (v.closest('.mt') || v) : v;
      return !tile.offsetParent;
    }

    function play(v) {
      if (hidden(v) || active.indexOf(v) > -1) return;
      while (active.length >= MAX) {
        var o = active.shift();
        if (o !== v) { try { o.pause(); } catch (e) {} }
      }
      active.push(v);
      if (!v.getAttribute('src') && v.getAttribute('data-src')) {
        v.preload = 'auto';
        v.setAttribute('src', v.getAttribute('data-src'));
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function pause(v) {
      var i = active.indexOf(v);
      if (i > -1) active.splice(i, 1);
      if (!v.paused) { try { v.pause(); } catch (e) {} }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(e.target); else pause(e.target);
        });
      }, { rootMargin: '250px 0px', threshold: 0.1 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      var t;
      var nudge = function () {
        var h = window.innerHeight || 0;
        vids.forEach(function (v) {
          if (hidden(v)) return;
          var r = v.getBoundingClientRect();
          if (!r.height) return;
          if (r.bottom > -h * 0.25 && r.top < h * 1.25) play(v); else pause(v);
        });
      };
      addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(nudge, 120); }, { passive: true });
      addEventListener('resize', function () { clearTimeout(t); t = setTimeout(nudge, 200); }, { passive: true });
      nudge();
      setTimeout(nudge, 600);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) active.slice().forEach(pause);
    });

    ['touchstart', 'click'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        active.forEach(function (v) {
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }, { once: true, passive: true });
    });
  }

  function boot() { setTimeout(init, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
